/**
 * Moderation Cases Completed Panel
 *
 * Displays the number of completed moderation cases
 */

import { Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationCasesCompletedPanelProps {
  casesCompleted: number;
  isLoading?: boolean;
}

export function ModerationCasesCompletedPanel({ casesCompleted, isLoading = false }: ModerationCasesCompletedPanelProps) {
  if (isLoading) {
    return (
      <div className={styles.panel}>
        <div className={styles.header}>
          <span className={styles.title}>CASES COMPLETED</span>
        </div>
        <div className={styles.content}>
          <Shimmer className={styles.shimmerValue} label="Loading cases completed count" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span className={styles.title}>CASES COMPLETED</span>
      </div>
      <div className={styles.content}>
        <Text as="div" className={styles.value}>
          {casesCompleted.toLocaleString()}
        </Text>
        <Text as="div" className={styles.subtitle}>
          All time
        </Text>
      </div>
    </div>
  );
}
